import { put, select, takeLatest } from 'redux-saga/effects'
import { ExposureConstants } from '../store/exposure.constants'
import { setExposureList } from '../store/exposure.actions'
import { IExposureState } from '../store/exposure.types'
import { getExposureSelector } from '../selectors/getExposure.selector'
import { initialExposure } from '../store/exposure.reducers'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setExposedTo() {
  const exposureState: IExposureState = yield select(getExposureSelector)
  const { exposedTo, exposureList, crewId } = exposureState
  const selectedExposure = exposureList.find((exp) => exp.crewId === crewId)
  try {
    if (selectedExposure) {
      selectedExposure.exposedTo = exposedTo
      yield put(setExposureList(exposureList))
    } else {
      const copyExposureList = [
        ...exposureList,
        {
          ...initialExposure,
          exposedTo,
          crewId,
        },
      ]
      yield put(setExposureList(copyExposureList))
    }
  } catch (e) {
    yield put(throwPcrException(`setExposedTo() error: ${e}`))
  }
}
export function* setExposedToSaga() {
  yield takeLatest([ExposureConstants.SET_EXPOSED_TO], setExposedTo)
}
